import { cva, type VariantProps } from 'class-variance-authority';

export const toggleVariants = cva(
  'mm:inline-flex mm:items-center mm:justify-center mm:gap-2 mm:rounded-md mm:text-sm mm:font-medium mm:transition-colors mm:hover:bg-muted mm:hover:text-muted-foreground mm:focus-visible:outline-none mm:focus-visible:ring-1 mm:focus-visible:ring-ring mm:disabled:pointer-events-none mm:disabled:opacity-50 mm:data-[state=on]:bg-accent mm:data-[state=on]:text-accent-foreground mm:[&_svg]:pointer-events-none mm:[&_svg]:size-4 mm:[&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'mm:bg-transparent',
        outline:
          'mm:border mm:border-input mm:bg-transparent mm:shadow-sm mm:hover:bg-accent mm:hover:text-accent-foreground',
      },
      size: {
        default: 'mm:h-9 mm:px-2 mm:min-w-9',
        sm: 'mm:h-8 mm:px-1.5 mm:min-w-8',
        lg: 'mm:h-10 mm:px-2.5 mm:min-w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export type ToggleVariantProps = VariantProps<typeof toggleVariants>;
